module.exports = __webpack_public_path__ + "static/5-c2be6df2247ff5064126d9f0cb9e09ab.jpg";